<template>
  <v-sheet class="pa-4 h-100">
    <v-sheet outlined class="rounded overflow-hidden h-100 d-flex flex-column">
      <div
        class="pa-2 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Manage Contractors</h3>
        <v-btn v-has="permissions.Contractors.Create" @click="update()" small color="primary"
          ><v-icon left>mdi-plus</v-icon> Add Contractor
        </v-btn>
        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
        <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
          <v-text-field
            hide-details
            outlined
            v-model="options.search"
            dense
            class="search-bar"
            placeholder="Search in contractors..."
            clearable
            prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-sheet>
      </div>
      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageText: 'Row/Page',
          itemsPerPageOptions: [15, 30, 50, 100, 200, 300, 400, 500, -1],
        }"
        :headers="contractorHeaders"
        :items="entries"
        :options.sync="options"
        @click:row="update"
        :loading="loading"
        :server-items-length="total">
        <template v-slot:[`item.createDate`]="{ item }">
          <div v-if="item.createDate">
            {{ $formatDate(item.createDate) }}
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="more-options-menu" dense>
              <v-list-item v-has="permissions.Contractors.Update" @click="update(item)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="success">mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Update</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-has="permissions.Contractors.Delete" @click="del(item.id)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Contractors...</p>
          </div>
        </template>
      </v-data-table>
      <EditContractor ref="editContractor"></EditContractor>
    </v-sheet>
  </v-sheet>
</template>
<script>
  import contractorHeaders from '@Contractors/config/contractor.headers';
  import { mapGetters } from 'vuex';
  import EditContractor from '@Contractors/Components/EditContractor.vue';
  import permissions from '@Share/config/permissions';
  import { $formatDate } from '@Utils';
import { $has } from '@/utils';

  export default {
    name: 'contractor-list',
    data() {
      return {
        contractorHeaders,
        permissions,
        timerId: null,
      };
    },
    computed: {
      ...mapGetters('CONTRACTOR', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
      }),
      options: {
        get() {
          return this.$store.getters['CONTRACTOR/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('CONTRACTOR/SET_OPTIONS', val);
        },
      },
    },
    methods: {
      $formatDate,
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('CONTRACTOR/GET');
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('CONTRACTOR/GET');
        }, 400);
      },
      update(contractorItem = null) {
        if(!$has(permissions.Contractors.Update))
          return;
        this.$refs.editContractor.open(contractorItem ? contractorItem.id : null, true);
      },
      del(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Contractor?',
          title: 'Delete Contractor',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                return this.$store.dispatch('CONTRACTOR/DELETE', id);
              },
            },
          },
        });
      },
    },
    watch: {
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
    },
    components: {
      EditContractor,
    },
  };
</script>
